/* eslint-disable no-param-reassign */
import reduce from 'lodash/reduce';

import { urlSearch } from '@/search';

const RAW_FILTER_MAPPINGS = {
  draft_state: () => urlSearch.getValue('draft_state')?.split(',') || null,
  owner: () =>
    urlSearch.getValue('owner') === null ? null : urlSearch.getValue('owner') === 'true',
  last_modified: () =>
    urlSearch.getValue('last_modified') === null
      ? null
      : Number(urlSearch.getValue('last_modified')),
  start_at: () => {
    const value = urlSearch.getValue('start_at');

    return value === null ? value : Number(value);
  },
  unpublished_changes: () => urlSearch.getValue('unpublished_changes') === 'true',
};

export default (searchFilters) => {
  return reduce(
    searchFilters,
    (filters, filter) => {
      const { key: filterKey } = filter;
      filters[filterKey] = RAW_FILTER_MAPPINGS[filterKey]();
      return filters;
    },
    {},
  );
};
